const bookChoicesBg = [
  {
    label: "Вълнуващи приключения и леки приятни истории.",
    value:
      'Exciting adventures and light enjoyable stories.{"Red":"3","Yellow":"2"}',
  },
  {
    label: "Мрачни истории и философски размишления.",
    value:
      'Mysteries and dark stories and philosophical, contemplative works.{"Black":"3","Gray":"2"}',
  },
  {
    label: "Истории, които вдъхновяват и трогателни семейни разкази.",
    value:
      'Inspiring stories of resilience and moving family narratives.{"Green":"3","Brown":"2"}',
  },
  {
    label: "Романи и фентъзи истории с магически елементи.",
    value:
      'Deep, contemplative novels and fantasy stories with magical elements.{"Blue":"3","Violet":"2"}',
  },
];

export default bookChoicesBg;
